import React from 'react';
import { useState, useEffect, useRef } from 'react';
import './Header.css';
import { Link } from 'react-router-dom';

function Header({ activeSection, setActiveSection }) {

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    const navItems = [
        { id: 'home', label: 'Home' },
        { id: 'about', label: 'About' },
        { id: 'projects', label: 'Projects' },
        { id: 'experience', label: 'Experience' },
        { id: 'contact', label: 'Contact' }
    ];

    const scrollToSection = (sectionId) => {
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        setMobileMenuOpen(false);
    };
  
  return (
    <nav className="fixed top-0 w-full bg-white/95 backdrop-blur-sm shadow-sm z-50">
        <div className="sd-navContainer max-w-8xl mx-auto px-6 py-4">
            <div className="flex justify-between items-center">
                <h1 className="text-2xl font-bold text-gray-800">Summer Flowers</h1>
                <div className="sd-navItems hidden md:flex space-x-8">
                    {navItems.map(item => (
                        <button
                            key={item.id}
                            onClick={() => scrollToSection(item.id)}
                            className={`nav-link text-gray-600 hover:text-emerald-600 font-medium ${
                                activeSection === item.id ? 'active' : ''
                            }`}
                        >
                            {item.label}
                        </button>
                    ))}
                </div>
                <button 
                    onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                    className="sd-mobileMenuIcon w-auto md:hidden p-2"
                >
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"></path>
                    </svg>
                </button>
            </div>
            {mobileMenuOpen && (
                <div className="sd-navItems md:hidden mt-4 pb-4">
                    {navItems.map(item => (
                        <button
                            key={item.id}
                            onClick={() => scrollToSection(item.id)}
                            className="block py-2 text-gray-600 hover:text-emerald-600 w-full text-left"
                        >
                            {item.label}
                        </button>
                    ))}
                </div>
            )}
        </div>
    </nav>
  );
}

export default Header;